import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

const dealershipRequest = (data) => ({
  ...(data || {}),
  requestedApp: 'dealership_web',
});

const callableError = (error, message) => {
  notifyPermissionDenied(error);
  return { success: 'no', message, error: error.message };
};

export const createTestDrive = async (data) => {
  try {
    const fn = httpsCallable(functions, 'createTestDriveV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error creating test drive:', error);
    return callableError(error, 'Error al crear el test drive');
  }
};

export const updateTestDrive = async (data) => {
  try {
    const fn = httpsCallable(functions, 'updateTestDriveV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error updating test drive:', error);
    return callableError(error, 'Error al actualizar el test drive');
  }
};

export const cancelTestDrive = async (data) => {
  try {
    const fn = httpsCallable(functions, 'cancelTestDriveV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error cancelling test drive:', error);
    return callableError(error, 'Error al cancelar el test drive');
  }
};

export const getTestDrivesByDealership = async (data) => {
  try {
    const fn = httpsCallable(functions, 'getTestDrivesByDealershipV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error getting test drives:', error);
    return callableError(error, 'Error al obtener los test drives');
  }
};

export const getTestDriveFeedbackAnalytics = async (data) => {
  try {
    const fn = httpsCallable(functions, 'getTestDrivesByDealershipV2');
    const result = await fn(dealershipRequest({ ...data, analytics: true }));
    return result.data;
  } catch (error) {
    console.error('Error getting feedback analytics:', error);
    return callableError(error, 'Error al obtener las analíticas de feedback');
  }
};

export const getTestDriveById = async (data) => {
  try {
    const fn = httpsCallable(functions, 'getTestDriveByIdV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error getting test drive:', error);
    return callableError(error, 'Error al obtener el test drive');
  }
};

export const getTestDriveForFeedback = async (data) => {
  try {
    const fn = httpsCallable(functions, 'getTestDriveForFeedbackV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error getting test drive for feedback:', error);
    return { success: 'no', message: 'Error al obtener el test drive', error: error.message };
  }
};

export const submitFeedback = async (data) => {
  try {
    const fn = httpsCallable(functions, 'submitFeedbackV2');
    const result = await fn(data);
    return result.data;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    return { success: 'no', message: 'Error al enviar el feedback', error: error.message };
  }
};

export const getAvailableSlots = async (data) => {
  try {
    const fn = httpsCallable(functions, 'getAvailableSlotsV2');
    const result = await fn(data);
    return result.data;
  } catch (error) {
    console.error('Error getting slots:', error);
    return callableError(error, 'Error al obtener horarios');
  }
};

export const addAccompanyingPeople = async (data) => {
  try {
    const fn = httpsCallable(functions, 'addAccompanyingPeopleV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error adding accompanying people:', error);
    return callableError(error, 'Error al agregar acompañantes');
  }
};

export const sendTestDriveNotifications = async (data) => {
  try {
    const fn = httpsCallable(functions, 'sendTestDriveNotificationsV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error sending notifications:', error);
    return callableError(error, 'Error al enviar notificaciones');
  }
};

export const deliverTestDriveKeys = async (data) => {
  try {
    const fn = httpsCallable(functions, 'deliverTestDriveKeysV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error delivering test drive keys:', error);
    return callableError(error, 'Error al entregar las llaves');
  }
};

export const reserveTestDriveSlot = async (data) => {
  try {
    const fn = httpsCallable(functions, 'reserveTestDriveSlotV2');
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error('Error reserving test drive slot:', error);
    return callableError(error, 'Error al reservar el turno de test drive');
  }
};

